const currenciesWithSymbolAfterAmount = ['SEK', 'DKK', 'BGN', 'HRK', 'LTL', 'NOK', 'PLN', 'RON', 'CHF', 'GEL'];
const currenciesWithSymbolBeforeAmount = ['XXX', 'GBP', 'BRL', 'CAD', 'LVL', 'CZK', 'USD', 'HUF', 'AUD', 'MXN', 'NZD', 'COP', 'INR', 'CLP', 'PEN', 'ZAR' ];
const currencyToSymbol = {
  EUR: '\u20AC',
  XXX: '\u20AC',
  SEK: ' \u006b\u0072',
  DKK: ' \u006b\u0072',
  GBP: '\u00a3',
  BRL: '\u0052\u0024',
  BGN: '\u043b\u0432',
  CAD: '\u0024',
  HRK: '\u006b\u006e',
  LVL: 'Ls',
  LTL: 'Lt',
  NOK: '\u006b\u0072',
  PLN: '\u007a\u0142',
  RON: '\u006c\u0065\u0069',
  CHF: '\u0043\u0048\u0046',
  CZK: '\u004b\u010d',
  USD: '\u0024',
  HUF: '\u0046\u0074 ',
  AUD: '\u0024',
  GEL: ' \u10da',
  MXN: ' \u0024',
  NZD: '\u0024',
  COP: '\u0024',
  INR: '\u20b9',
  CLP: '\u0024',
  PEN: '\u0053\u002F',
  ZAR: 'R'
};
function formatAmount(num, currency) {
  let formattedAmount = num/1000;

  // Special case for COP currency - uses '.'  as thousands separator and shows no decimals
  if (currency === 'COP') {
    // period should be used as thousands separator and decimals are not allowed for COP currency
    // as locale 'co' does not exist, locale 'de' has been used as it uses period for thousands
    formattedAmount = Math.trunc(formattedAmount).toLocaleString('de');
  }
  return Number.parseFloat(formattedAmount).toFixed(2);
}


export default function getFormattedCurrency(amount, market, currency) {
  const currencyUC = currency.toUpperCase();
  const marketUC = market.toUpperCase();
  const formattedAmount = formatAmount(amount, currency);

  // Special case for EUR currency - is formatted according to the market
  if (currencyUC === 'EUR') {
    if (marketUC === 'DE' || marketUC === 'ES' || marketUC === 'FR') {
      return formattedAmount + currencyToSymbol[currencyUC];
    }
    return currencyToSymbol[currencyUC] + formattedAmount;
  }

  if (currenciesWithSymbolAfterAmount.includes(currencyUC)) {
    return formattedAmount + currencyToSymbol[currencyUC];
  }

  if (currenciesWithSymbolBeforeAmount.includes(currencyUC)) {
    return currencyToSymbol[currencyUC] + formattedAmount;
  }

  return formattedAmount;
}
